import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import TextInput from '../../../components/input';
import useForm from '../../../customHooks/useForm';
import useToast from '../../../customHooks/useToast';
import { DELETE_MOBILE_CUSTOMER } from '../../../graphql/admin_mutations';
import AdminModal from '../../../components/AdminModal';
import InfoIconNew from '../../../svgs/InfoIconNew';

interface IDeleteCustomerProfile{
  closeModal?:any;
  customerId:string;
  isShow: any,
}
const DeleteCustomerProfile = ({
  closeModal, customerId, isShow,
}:IDeleteCustomerProfile) => {
  const Toast = useToast();
  const { push } = useHistory();
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [showModalChildren, setShowModalChildren] = useState(true);

  const [deleteProfile, { loading: deleteProfileLoading }] = useMutation<
  { removeUser: any },
  any
>(DELETE_MOBILE_CUSTOMER);
  const {
    formValues, handleChange, resetForm,
  } = useForm(
    {
      reason: '',
    },
    {},
    Toast,
  );
  const handleReasonForDeleting = formValues?.reason?.length > 3;

  const handleConfirmActivation = async () => {
    if (formValues?.reason === '') {
      Toast.error('Please provide a reason for deleting this profile');
      return;
    }
    if (!deleteProfileLoading) {
      try {
        const res = await deleteProfile({
          variables: { id: customerId, reason: formValues?.reason },
        });

        resetForm({
          reason: '',
        });

        if (res?.data?.removeUser && res?.data?.removeUser?.status === 200) {
          Toast.success(res?.data?.removeUser?.message || 'Operation was successful');
          setIsSuccessful(true);
          setShowModalChildren(false);
        } else {
          Toast.error(res?.data?.removeUser?.message || 'Operation Failed');
        }
      } catch (e) {
        resetForm({
          reason: '',
        });
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };
  const handleCloseModal = () => {
    if (isSuccessful) {
      push('/customers?page=1&search=');
    }
    closeModal();
  };

  return (
    <div>
      <AdminModal
        headText={isSuccessful ? 'Profile Deleted Successfully!' : 'Delete Profile?'}
        subText={isSuccessful ? 'You have successfully deleted this profile and it will no longer be accessible on your dashboard' : 'Kindly provide a reason as to why you would want to delete this profile.'}
        actionBtnName={deleteProfileLoading ? 'Deleting...' : 'delete'}
        handleModalAction={handleConfirmActivation}
        topIcon={<InfoIconNew />}
        isShow={isShow}
        isSuccess={isSuccessful}
        isActionBtnDisabled={showModalChildren && !handleReasonForDeleting}
        onClickAway={() => {}}
        onClose={handleCloseModal}
        isLoading={deleteProfileLoading}
      >
        {showModalChildren && (
        <div>
          <TextInput
            rows={5}
            name="reason"
            value={formValues?.reason}
            multiline
            label="Reason"
            isRequired
            customOnChange={handleChange}
            backgroundColor="#F9F9F9"
          />
        </div>
        )}
      </AdminModal>

    </div>
  );
};
export default DeleteCustomerProfile;
